import { META_PIXEL_ID, LEAD_WEBHOOK_URL } from './config';

declare global { interface Window { fbq?: any; _fbq?: any; } }

export function initPixel() {
  if (typeof window === 'undefined' || window.fbq || !META_PIXEL_ID || META_PIXEL_ID === 'YOUR_PIXEL_ID') return;
  /* eslint-disable */
  (function (f: any, b: any, e: any, v: any) {
    if (f.fbq) return;
    const n: any = (f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); });
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
    const t = b.createElement(e); t.async = true; t.src = v;
    const s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', META_PIXEL_ID);
}

export function track(event: string, params?: Record<string, any>) {
  try { if (window.fbq) window.fbq('track', event, params || {}); } catch (e) {}
}

// keepalive: el envío se completa aunque la persona cierre la pestaña o cambie de página
export async function sendLead(payload: Record<string, any>) {
  if (!LEAD_WEBHOOK_URL) return;
  try { await fetch(LEAD_WEBHOOK_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), keepalive: true }); } catch {}
}

export function getLead(): Record<string, any> {
  try { return JSON.parse(sessionStorage.getItem('chale_lead') || '{}'); } catch { return {}; }
}
export function saveLead(data: Record<string, any>) {
  try { sessionStorage.setItem('chale_lead', JSON.stringify({ ...getLead(), ...data })); } catch {}
}
export function firstName() {
  return String(getLead().name || '').trim().split(' ')[0];
}
